export default class Scrolly {
  constructor(element) {
    this.element = element;

    this.options = {
      rootMargin: '0px',
    };

    this.init();
  }

  setOptions() {
    if ('scrollyMargin' in this.element.dataset) {
      const margin = parseFloat(this.element.dataset.scrollyMargin) || 0;
      console.log(margin);
      this.options.rootMargin = `${-margin}px 0px ${-margin}px 0px`;
    }
  }

  init() {
    this.setOptions();

    // Crée un IntersectionObserver qui appellera watch() lorsqu'au moins un élément voulu entre/sort du viewport
    const observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options,
    );

    // Ajoute tous les éléments ayant un attribut data-scrolly à l'instance d'IntersectionObserver
    const items = this.element.querySelectorAll('[data-scrolly]');
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      observer.observe(item);

      // Permet de donner un délai aux enfants directs de l'éléments scrolly
      if ('scrollyDelay' in item.dataset) {
        for (let i = 0; i < item.children.length; i++) {
          const child = item.children[i];
          child.style.transitionDelay = `${parseFloat(item.dataset.scrollyDelay * i) || 100 * i}ms`;
        }
      }
    }
  }

  // Lorsqu'au moins un élément observé entre ou quitte le viewport
  watch(entries, observer) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;
      // Si l'élément est dans le viewport
      if (entry.isIntersecting) {
        target.classList.add('is-active'); // Ajout de la classe pour animation
        if ('noRepeat' in target.dataset) observer.unobserve(target); // N'observe plus les entrées/sorties de l'élément pour que l'animation ne se reproduise plus
      } else {
        target.classList.remove('is-active'); // Retire la classe pour animation
      }
    }
  }
}
